<!-- Floating status indicator for showing upload progress -->

<template>
  <div id="upload-indicator" v-if="uploadStatus.uploading">
    <div id="upload-indicator-header">
      {{ $t('components.upload_indicator.title')}}
    </div>
    <div id="upload-indicator-content">
      {{ $t('components.upload_indicator.message')}}
      <v-btn variant="plain" color="primary" @click="cancel()">
        {{ $t('components.upload_indicator.cancel')}}
      </v-btn>
    </div>
    <div id="upload-indicator-progress-background">
      <div id="upload-indicator-progress"
      v-bind:style="'width: ' + uploadStatus.progress + '%'">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadIndicator',
  props: [],
  computed: {
    uploadStatus() {
      return this.$store.getters['videos/uploadStatus'];
    },
  },
  methods: {
    async cancel() {
      await this.$store.dispatch('videos/cancelUpload');
    },
  },
};
</script>

<style lang="css">
  #upload-indicator {
    width: 500px;
    position: fixed;
    bottom: 20px;
    right: 20px;
    background: white;
    box-shadow: 0px 0px 12px rgba(0,0,0,0.33);
    border-radius: 4px;
    z-index: 1010;
  }

  @media (max-width: 600px) {
    #upload-indicator {
      width: 90%;
      right: 5%;
      bottom: 5%;
    }
  }

  #upload-indicator-header {
    border-bottom: 1px solid #cccccc;
    padding: 15px 20px 15px 20px;
    font-size: 18px;
    font-weight: bold;
  }
  #upload-indicator-content {
    padding: 20px;
  }
  #upload-indicator-progress {
    height: 15px;
    background: var(--light-green);
    width: 0%;
    transform: translate(0, -1px);
  }
  #upload-indicator-progress-background {
    height: 15px;
    margin: 0px 20px 20px 20px;
    border: 1px solid #cccccc;
  }
</style>
